module["exports"] = [
  "###-###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/address/postcode.js
 ** module id = 723
 ** module chunks = 0
 **/